var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4997 18.3335H1.83301",
    stroke: "#00067E",
    strokeWidth: 1.83333,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5372 4.04625C12.2531 3.33029 13.414 3.33029 14.1299 4.04625C14.8459 4.76221 14.8459 5.92301 14.1299 6.63898L6.53693 14.232L4.0726 14.3962C3.90659 14.4073 3.76886 14.2695 3.77992 14.1035L3.9442 11.6393L11.5372 4.04625Z",
    stroke: "#00067E",
    strokeWidth: 1.83333,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.77ea54c22180b724e5d8d3ff40776ca4.svg";
export { ForwardRef as ReactComponent };